module.exports = __webpack_public_path__ + "static/media/img45.ce64736d.jpg";